import { Component, OnInit } from '@angular/core';
import{ ThemingService } from 'src/app/theming.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  theming: any = {};
  constructor(
    public themingService: ThemingService
  ) { }

  ngOnInit(): void {
    this.theming = this.themingService.shopTheming[0];
  }

}
